"use strict";
var lodash_1 = require("lodash");
var gpml_utilities_1 = require("./gpml-utilities");
var biopaxEdgeTypes = [
    'Interaction',
    'Control',
    'TemplateReactionRegulation',
    'Catalysis',
    'Modulation',
    'Conversion',
    'BiochemicalReaction',
    'TransportWithBiochemicalReaction',
    'ComplexAssembly',
    'Degradation',
    'Transport',
    'TransportWithBiochemicalReaction',
    'GeneticInteraction',
    'MolecularInteraction',
    'TemplateReaction'
];
var biopaxEdgeTypesPrefixed = biopaxEdgeTypes.map(function (x) { return 'biopax:' + x; });
// Handle 'Style' attributes for GPML 'Group' elements,
// using the closest Biopax term available for the mappings below.
// Once all the elements are converted, we come back to this and
// set any 'Pathways' with no interactions to be Complexes.
var GROUP_STYLE_TO_BIOPAX = {
    'Group': 'Pathway',
    'None': 'Pathway',
    'Complex': 'Complex',
    'Pathway': 'Pathway'
};
var GROUP_STYLE_TO_DRAW_AS = {
    'Group': 'None',
    'None': 'None',
    'Complex': 'Complex',
    'Pathway': 'Rectangle'
};
exports.GROUP_DEFAULTS = {
    attributes: {
        Align: {
            name: 'Align',
            value: 'Center'
        },
        Color: {
            name: 'Color',
            value: '808080'
        },
        Valign: {
            name: 'Valign',
            value: 'Middle'
        },
        FontSize: {
            name: 'FontSize',
            value: 1
        },
        FontWeight: {
            name: 'FontWeight',
            value: 'Bold'
        },
        LineThickness: {
            name: 'LineThickness',
            value: 1
        },
        FillOpacity: {
            name: 'FillOpacity',
            value: 0.1
        },
        Style: {
            name: 'Style',
            value: 'None'
        }
    }
};
function applyDefaults(gpmlElement, defaults) {
    var defaultsByStyle = {
        None: {
            attributes: {
                Padding: {
                    name: 'Padding',
                    value: 8
                },
                ShapeType: {
                    name: 'ShapeType',
                    value: 'Rectangle'
                },
                LineStyle: {
                    name: 'LineStyle',
                    value: 'Broken'
                },
                FillColor: {
                    name: 'FillColor',
                    value: 'B4B464'
                },
            }
        },
        Group: {
            attributes: {
                Padding: {
                    name: 'Padding',
                    value: 8
                },
                ShapeType: {
                    name: 'ShapeType',
                    value: 'None'
                },
                LineStyle: {
                    name: 'LineStyle',
                    value: 'Broken'
                },
                FillColor: {
                    name: 'FillColor',
                    value: 'Transparent'
                },
            }
        },
        Complex: {
            attributes: {
                Padding: {
                    name: 'Padding',
                    value: 11
                },
                ShapeType: {
                    name: 'ShapeType',
                    value: 'Complex'
                },
                LineStyle: {
                    name: 'LineStyle',
                    value: 'Solid'
                },
                FillColor: {
                    name: 'FillColor',
                    value: 'B4B464'
                },
            }
        },
        Pathway: {
            attributes: {
                Padding: {
                    name: 'Padding',
                    value: 8
                },
                ShapeType: {
                    name: 'ShapeType',
                    value: 'Rectangle'
                },
                LineStyle: {
                    name: 'LineStyle',
                    value: 'Broken'
                },
                FillColor: {
                    name: 'FillColor',
                    value: '00FF00'
                },
            }
        }
    };
    gpmlElement.attributes.Style = gpmlElement.attributes.Style || { value: 'None' };
    var groupStyle = gpmlElement.attributes.Style;
    gpmlElement = gpml_utilities_1.applyDefaults(gpmlElement, [defaultsByStyle[groupStyle.value], exports.GROUP_DEFAULTS, defaults]);
    return gpmlElement;
}
exports.applyDefaults = applyDefaults;
;
// TODO should we allow padding to be a value like '0.5em'?
function getGroupDimensions(padding, borderWidth, groupContents) {
    var dimensions = {};
    dimensions.topLeftCorner = {
        x: Infinity,
        y: Infinity
    };
    dimensions.bottomRightCorner = {
        x: 0,
        y: 0
    };
    groupContents.forEach(function (groupContent) {
        var points = groupContent.points;
        if (groupContent.hasOwnProperty('x') && groupContent.hasOwnProperty('y') &&
            groupContent.hasOwnProperty('width') && groupContent.hasOwnProperty('height')) {
            dimensions.topLeftCorner.x = Math.min(dimensions.topLeftCorner.x, groupContent.x);
            dimensions.topLeftCorner.y = Math.min(dimensions.topLeftCorner.y, groupContent.y);
            dimensions.bottomRightCorner.x = Math.max(dimensions.bottomRightCorner.x, groupContent.x + groupContent.width);
            dimensions.bottomRightCorner.y = Math.max(dimensions.bottomRightCorner.y, groupContent.y + groupContent.height);
        }
        else if (!!points) {
            var firstPoint = points[0];
            var firstPointX = firstPoint.x;
            var firstPointY = firstPoint.y;
            var lastPoint = points[points.length - 1];
            var lastPointX = lastPoint.x;
            var lastPointY = lastPoint.y;
            dimensions.topLeftCorner.x = Math.min(dimensions.topLeftCorner.x, firstPointX, lastPointX);
            dimensions.topLeftCorner.y = Math.min(dimensions.topLeftCorner.y, firstPointY, lastPointY);
            dimensions.bottomRightCorner.x = Math.max(dimensions.bottomRightCorner.x, firstPointX, lastPointX);
            dimensions.bottomRightCorner.y = Math.max(dimensions.bottomRightCorner.y, firstPointY, lastPointY);
        }
        else {
            throw new Error("Unexpected content (id: \"" + groupContent.id + "\", type: \"" + groupContent.kaavioType + "\") in Group");
        }
        dimensions.x = dimensions.topLeftCorner.x - padding - borderWidth;
        dimensions.y = dimensions.topLeftCorner.y - padding - borderWidth;
        dimensions.width = (dimensions.bottomRightCorner.x - dimensions.topLeftCorner.x) + 2 * (padding + borderWidth);
        dimensions.height = (dimensions.bottomRightCorner.y - dimensions.topLeftCorner.y) + 2 * (padding + borderWidth);
    });
    if (typeof dimensions.x === 'undefined' ||
        isNaN(dimensions.x) ||
        dimensions.x === null ||
        typeof dimensions.y === 'undefined' ||
        isNaN(dimensions.y) ||
        dimensions.y === null ||
        typeof dimensions.width === 'undefined' ||
        isNaN(dimensions.width) ||
        dimensions.width === null ||
        typeof dimensions.height === 'undefined' ||
        isNaN(dimensions.height) ||
        dimensions.height === null) {
        throw new Error('Error calculating group dimensions. Cannot calculate one or more of the following: x, y, width, height.');
    }
    return dimensions;
}
exports.getGroupDimensions = getGroupDimensions;
;
function postProcess(data, group) {
    var containedElements = group.contains.map(function (id) { return data.elementMap[id]; });
    var dimensions = getGroupDimensions(group.padding, group.borderWidth, containedElements);
    group.y = dimensions.y;
    group.x = dimensions.x;
    group.width = dimensions.width;
    group.height = dimensions.height;
    // Convert GPML Group Style to a Biopax class, like Complex
    var containsEdge = containedElements.reduce(function (accumulator, item) {
        var isEdge = gpml_utilities_1.intersectsLSV(biopaxEdgeTypes, item.type);
        accumulator = accumulator || isEdge;
        return accumulator;
    }, false);
    var biopaxType = containsEdge ? (GROUP_STYLE_TO_BIOPAX[group['gpml:Style']] || 'Pathway') : 'Complex';
    group.type = gpml_utilities_1.unionLSV(group.type, biopaxType);
    return lodash_1.omit(group, ['gpml:Style']);
}
exports.postProcess = postProcess;
;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/gpml2pvjson/lib/group.js
// module id = 319
// module chunks = 0